import axios from "axios";
import { Message } from "element-ui";
import store from "../store";

// 纯前端模式 - 模拟API响应
const MOCK_MODE = false;

// 模拟数据
const mockData = {
  token: "mock-token-123456",
  user: {
    id: 1,
    name: "管理员",
    role: "admin",
  },
};

// 模拟API响应函数
const mockResponse = (data, delay = 300) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: 200,
        msg: "success",
        data: data,
      });
    }, delay);
  });
};

if (!MOCK_MODE) {
  // 根据当前环境自动设置API地址
  const isProduction = window.location.hostname !== "localhost";

  // 使用域名而不是IP地址，这样SSL证书就能正确匹配
  const protocol = window.location.protocol;
  const apiHost = "web.faduobang.com";

  axios.defaults.baseURL = process.env.VUE_APP_CRM_BUILD === "1"
    ? window.location.origin
    : `${protocol}//${apiHost}`;

  axios.interceptors.response.use(
    (success) => {
      return success.data;
    },
    (error) => {
      if (error.response) {
        const status = error.response.status;
        const url = error.response.config ? error.response.config.url : "";
        // 404: 接口不存在，静默处理，由各组件自行决定是否提示用户
        if (status == 404) {
          console.warn(`[API 404] 接口不存在: ${url}`);
        } else if (status == 504) {
          Message.error({ message: "服务器响应超时，请稍后重试" });
        } else if (status == 403) {
          Message.error({ message: "权限不足，请联系管理员" });
        } else if (status == 401) {
          window.location.hash = "#/login";
        } else {
          if (error.response.data && error.response.data.msg) {
            Message.error({ message: error.response.data.msg });
          } else {
            Message.error({ message: `请求失败: ${status}` });
          }
        }
      } else if (error.request) {
        Message.error({ message: "网络连接失败，请检查网络" });
      } else {
        Message.error({ message: error.message || "未知错误!" });
      }

      return Promise.reject(error);
    }
  );
}

let base = "/admin";

export const postKeyValueRequest = (url, params) => {
  if (MOCK_MODE) {
    // 模拟不同的API响应
    if (url.includes("/Login/checkToken")) {
      return mockResponse({ valid: true });
    }
    return mockResponse(mockData);
  }

  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let i in data) {
          if (Array.isArray(data[i])) {
            for (let j = 0; j < data[i].length; j++) {
              ret +=
                encodeURIComponent(i + "[" + j + "]") +
                "=" +
                encodeURIComponent(data[i][j]) +
                "&";
            }
          } else {
            ret +=
              encodeURIComponent(i) + "=" + encodeURIComponent(data[i]) + "&";
          }
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Request-Token": store.getters.GET_TOKEN || "",
    },
  });
};

export const postRequest = (url, params) => {
  if (MOCK_MODE) {
    // 模拟不同的API响应
    if (url.includes("/Login/checkToken")) {
      return mockResponse({ valid: true });
    }
    return mockResponse(mockData);
  }

  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: {
      "Login-Token": store.getters.GET_TOKEN || "",
    },
  });
};

export const putRequest = (url, params) => {
  if (MOCK_MODE) {
    return mockResponse(mockData);
  }

  return axios({
    method: "put",
    url: `${base}${url}`,
    data: params,
    headers: {
      "Login-Token": store.getters.GET_TOKEN || "",
    },
  });
};

export const getRequest = (url, params) => {
  if (MOCK_MODE) {
    return mockResponse(mockData);
  }

  return axios({
    method: "get",
    url: `${base}${url}`,
    params: params,
    headers: {
      "Login-Token": store.getters.GET_TOKEN || "",
    },
  });
};

export const deleteRequest = (url, params) => {
  if (MOCK_MODE) {
    return mockResponse({ success: true });
  }

  return axios({
    method: "delete",
    url: `${base}${url}`,
    params: params,
    headers: {
      "Login-Token": store.getters.GET_TOKEN || "",
    },
  });
};
